import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import { Box, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { PersonFilled, PersonRegular, ShieldLockFilled, ShieldLockRegular, SparkleFilled, SparkleRegular, TableSettingsFilled, TableSettingsRegular } from '@fluentui/react-icons';
import { PageHeader } from '@ui/layout/Layout/components';
import NavigationTile from '@ui/components/common/NavigationTile';
import useSettingsStyles from './useSettingsStyles';
import BlacklistWhitelist from './components/BlacklistWhitelist';
import { useLocation, useNavigate } from 'react-router-dom';
import ScorecardConfiguration from './components/ScorecardConfiguration';
import { AccountInformation } from './components/AccountInformation';
import ApplicationSettings from './components/ApplicationSettings';
var TabEnum;
(function (TabEnum) {
    TabEnum["AccountInformation"] = "Account Information";
    TabEnum["ApplicationSettings"] = "Application Settings";
    TabEnum["Blacklist&Whitelist"] = "Blacklist & Whitelist";
    TabEnum["ScorecardConfiguration"] = "Scorecard Configuration";
})(TabEnum || (TabEnum = {}));
const Settings = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const { tabListStyles } = useSettingsStyles();
    const [selectedTab, setSelectedTab] = useState(TabEnum.AccountInformation);
    const tabs = useMemo(() => [
        {
            preIcon: PersonRegular,
            preIconSize: 20,
            preIconColor: theme.palette.text.primary,
            name: TabEnum.AccountInformation,
            selectedIcon: PersonFilled
        },
        {
            preIcon: SparkleRegular,
            preIconSize: 20,
            preIconColor: theme.palette.text.primary,
            name: TabEnum.ApplicationSettings,
            selectedIcon: SparkleFilled
        },
        {
            preIcon: ShieldLockRegular,
            preIconSize: 20,
            preIconColor: theme.palette.text.primary,
            name: TabEnum['Blacklist&Whitelist'],
            selectedIcon: ShieldLockFilled
        },
        {
            preIcon: TableSettingsRegular,
            preIconSize: 20,
            preIconColor: theme.palette.text.primary,
            name: TabEnum.ScorecardConfiguration,
            selectedIcon: TableSettingsFilled
        }
    ], [theme.palette.text.primary]);
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const tabParam = params.get('tab');
        const validTab = tabs.find((tab) => tab.name === tabParam);
        if (validTab) {
            setSelectedTab(validTab.name);
        }
        else {
            const firstTab = tabs[0].name;
            navigate(`/settings?tab=${firstTab}`, { replace: true });
            setSelectedTab(firstTab);
        }
    }, [location.search, navigate, tabs]);
    const handleSelectTab = (newTab) => {
        if (newTab !== selectedTab) {
            const params = new URLSearchParams(location.search);
            params.set('tab', newTab);
            navigate(`/settings?${params.toString()}`, { replace: true });
            setSelectedTab(newTab);
        }
    };
    const renderTabLayout = (selectedTab) => {
        switch (selectedTab) {
            case TabEnum['Blacklist&Whitelist']:
                return _jsx(BlacklistWhitelist, {});
            case TabEnum.ScorecardConfiguration:
                return _jsx(ScorecardConfiguration, {});
            case TabEnum.AccountInformation:
                return _jsx(AccountInformation, {});
            case TabEnum.ApplicationSettings:
                return _jsx(ApplicationSettings, {});
            default:
                return _jsx(_Fragment, {});
        }
    };
    return (_jsxs(React.Fragment, { children: [_jsx(PageHeader, { title: 'Settings' }), _jsxs(Grid, { container: true, className: 'settings-main-container', spacing: 3, children: [_jsx(Grid, { size: { md: 12, lg: 2.25 }, children: _jsx(Box, { className: 'tab-list', sx: { ...tabListStyles, flexDirection: { md: 'row', lg: 'column' } }, children: tabs.map(({ name, preIcon, selectedIcon, preIconColor, preIconSize }) => (_jsx(NavigationTile, { name: name, PrefixIcon: selectedTab === name ? selectedIcon : preIcon, prefixIconsize: preIconSize, prefixIconcolor: preIconColor, onClick: () => handleSelectTab(name), isSelected: selectedTab === name }))) }) }), _jsx(Grid, { size: { md: 12, lg: 9.75 }, children: renderTabLayout(selectedTab) })] })] }));
};
export default Settings;
